import "@/features/claimsummary/style.scss";
import { MotifIcon, MotifProgressLoader } from "@ey-xd/motif-react";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import Banner, { BannerElement } from "@/components/Banner/Banner";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import { Summary } from "@/features/claimsummary/summary/summary";
import TabPanel from "@/components/TabPanel/TabPanel";
import { useParams } from "react-router-dom";
import {
  useGetclaimStageAndDocumentApiDataQuery,
  useGetClaimStatusApiDataQuery,
  useGetClaimSummaryViewApiDataQuery,
} from "@/services/claimSummary/caseSummaryReducer";
import { EditSummary } from "./editSummary/editSummary";
import { useEffect, useState } from "react";
import { useCase } from "../case/use-case";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import AttributeHistoryTab from "./historyClaims/attributeHistory";
import ClaimsHistoryTab from "./historyClaims/clamiHistory";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import { formatAmountUnitDecimalPlace } from "@/utility/common";
import { ActiveTabsOrder } from "@/menuData";
import { setRetainClaimId } from "../retain_state/retainStateSlice";
export const ClaimSummary = () => {
  const { caseId, creditorId, debtorId, claimId } = useParams();
  const caseData = useCase();
  const { t } = useTranslation();
  const [showDiscardPopup, setShowDiscardPopup] = useState(false);
  const [showEditPage, setEditPage] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const { data: claimStageData } =
    useGetclaimStageAndDocumentApiDataQuery(claimId);
  const { data: getClaimStatus } = useGetClaimStatusApiDataQuery(
    claimStageData?.definitionIds.claimStatusDefinitionId,
    { skip: !claimStageData }
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setRetainClaimId({ claimId: claimId }));
  }, [dispatch, claimId]);
  const { data, isLoading } = useGetClaimSummaryViewApiDataQuery(claimId);
  const creditorBanner = {
    creditorTtl: "pages.claims.bannerDetails.title",
    creditorName: data?.claimSummary?.claimReference,
  };
  let discardDetails = useSelector((e: any) => e.discardChangesDatas.data);

  function handleClose() {
    setEditPage(false);
    setShowDiscardPopup(false);
  }
  function handleReject() {
    setShowDiscardPopup(false);
  }
  const bannerElements: BannerElement[] = [
    {
      label: "pages.claims.bannerDetails.label1",
      value: data?.claimSummary?.creditorName
        ? data?.claimSummary?.creditorName
        : "-",
      elementKey: "caseID",
      id: data?.claimSummary?.creditorId ? data?.claimSummary?.creditorId : "",
    },
    {
      label: "pages.claims.bannerDetails.label4",
      value: data?.claimSummary?.debtorName
        ? data?.claimSummary?.debtorName
        : "-",
      elementKey: "caseID",
      id: data?.claimSummary?.debtorId ? data?.claimSummary?.debtorId : "",
      navLink: `/case/${caseId}/debtor/edit/${data?.claimSummary?.debtorId}`,
    },
    {
      label: "pages.claims.bannerDetails.label2",
      value: data?.claimSummary?.claimAmount
        ? `${formatAmountUnitDecimalPlace(
            data?.claimSummary?.claimAmount,
            caseData?.defaultUnit?.decimalPlace
          )} ${caseData?.defaultUnit?.name}`
        : "-",
      addedClassName: "align-right",
    },
    {
      label: "pages.claims.bannerDetails.label3",
      value: claimStageData?.instanceData?.claimStageName
        ? claimStageData?.instanceData?.claimStageName
        : "-",
    },
    {
      label: "pages.claims.bannerDetails.label5",
      value: claimStageData?.instanceData?.claimStatusName
        ? claimStageData?.instanceData?.claimStatusName
        : "-",
    },
  ];

  let breadcrumbParent: any = [
    {
      label: "Case",
      value: caseData?.caseName,
      elementKey: "case",
      text: caseData?.caseName,
      url: showEditPage
        ? `/case/${caseId}/claim/${claimId}`
        : `/case/${caseId}/?activeTab=${
            debtorId
              ? ActiveTabsOrder.DEBTOR
              : creditorId
              ? ActiveTabsOrder.CREDITOR
              : ActiveTabsOrder.CLAIM
          }`, //Check this
      icon: <MotifIcon src={IconoirArrowLeft} />,
      blockNavigation: showEditPage,
    },
  ];
  if (debtorId) {
    breadcrumbParent = [
      ...breadcrumbParent,
      {
        label: "Debtor",
        value: data?.claimSummary?.debtorName,
        elementKey: "debtor",
        text: data?.claimSummary?.debtorName,
        url: `/case/${caseId}/debtor/edit/${debtorId}?activeTab=1`,
        icon: <MotifIcon src={IconoirArrowLeft} />,
        blockNavigation: showEditPage,
      },
    ];
  }
  if (creditorId || (!creditorId && !debtorId)) {
    breadcrumbParent = [
      ...breadcrumbParent,
      {
        label: "Creditor",
        value: data?.claimSummary?.creditorName,
        elementKey: "creditor",
        text: data?.claimSummary?.creditorName,
        url: `/case/${caseId}/creditor/${
          creditorId || data?.claimSummary?.creditorId
        }?activeTab=1`,
        icon: <MotifIcon src={IconoirArrowLeft} />,
        blockNavigation: showEditPage,
      },
    ];
  }
  const breadcrumbItems = [
    ...breadcrumbParent,
    {
      label: "Current Claim",
      value: data?.claimSummary?.claimReference,
      elementKey: "claim",
      text: t("pages.claims.breadCrums.claimId", {
        refernceId: data?.claimSummary?.claimReference,
      }),
      url: "/",
      disabled: true,
    },
  ];
  const tabPanelData = {
    title: [
      "pages.claims.tabPannelDetails.summary",
      "pages.claims.tabPannelDetails.claimHistory",
      "pages.claims.tabPannelDetails.attributeHistory",
    ],
    content: [
      <div>
        {showEditPage ? (
          <EditSummary
            setEditPage={setEditPage}
            setSuccessMsg={setSuccessMsg}
            resolvedStatus={getClaimStatus?.isResolveStatus}
          />
        ) : (
          <Summary
            setEditPage={setEditPage}
            unitName={caseData?.defaultUnit?.name}
            resolvedStatus={getClaimStatus?.isResolveStatus}
          />
        )}
      </div>,
      <div>
        <ClaimsHistoryTab setEditPage={setEditPage} />
      </div>,
      <div>
        <AttributeHistoryTab setEditPage={setEditPage} />
      </div>,
    ],
  };
  return (
    <>
      {successMsg && (
        <NotificationGrid
          show={true}
          type="success"
          message={"pages.claims.commonFieldLabels.claimUpdatedSuccesfully"}
        />
      )}
      {isLoading ? (
        <MotifProgressLoader variant="circular" size="xs" />
      ) : (
        <>
          <div
            onClick={(e) => {
              if (showEditPage) {
                if (discardDetails.editMode) {
                  setShowDiscardPopup(true);
                } else {
                  setEditPage(false);
                }
              }
            }}
          >
            <Breadcrumb
              items={breadcrumbItems}
              ariaLabel="Breadcrumb navigation"
            />
          </div>
          <Banner
            bannerName={creditorBanner.creditorTtl}
            bannerNameValue={creditorBanner.creditorName}
            elements={bannerElements}
          />
        </>
      )}

      <div className="ccwp_table_tabpanel ccwp_claim_summary_view">
        <TabPanel data={tabPanelData} defaultActiveKey={0} />
      </div>
      <ConfirmationModal
        isVisible={showDiscardPopup}
        setIsVisible={handleClose}
        cancelBtnApproveHandler={handleClose}
        cancelBtnRejectHandler={handleReject}
      />
    </>
  );
};
